import {Spin} from '@superweb/ui'
import React from 'react'

import styleClasses from './classes.module.css'

export function Loader() {
  return (
    <div className={styleClasses.loader}>
      <Spin size="xs" />
    </div>
  )
}
